import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid } from "recharts";
import {
  EVENT_TYPES,
  scrapingChartConfig,
  DailyChartPoint,
} from "@/lib/scrapingEvents";

// Débit de scraping par jour, empilé par type d'évènement. Partagé entre la
// page scraping-stats et le cockpit worker (onglet Vue d'ensemble).
export function ScrapingDailyAreaChart({
  chartData,
  loading,
  className,
}: {
  chartData: DailyChartPoint[];
  loading?: boolean;
  className?: string;
}) {
  if (loading) {
    return <div className="text-sm text-muted-foreground py-8 text-center">Chargement...</div>;
  }
  if (chartData.length === 0) {
    return <div className="text-sm text-muted-foreground py-8 text-center">Aucune donnée</div>;
  }
  return (
    <ChartContainer config={scrapingChartConfig} className={className ?? "max-h-[300px] w-full"}>
      <AreaChart data={chartData}>
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey="date"
          tickLine={false}
          axisLine={false}
          tickFormatter={(v) => {
            // v = "YYYY-MM-DD" : on parse les parties directement pour éviter le
            // décalage UTC→local de new Date() (jour décalé en UTC-N).
            const parts = String(v).split("-");
            return parts.length === 3
              ? `${parseInt(parts[2], 10)}/${parseInt(parts[1], 10)}`
              : v;
          }}
        />
        <YAxis tickLine={false} axisLine={false} />
        <ChartTooltip content={<ChartTooltipContent />} />
        {EVENT_TYPES.map((type) => (
          <Area
            key={type}
            type="monotone"
            dataKey={type}
            stackId="1"
            fill={`var(--color-${type})`}
            stroke={`var(--color-${type})`}
            fillOpacity={0.4}
          />
        ))}
      </AreaChart>
    </ChartContainer>
  );
}
